import type { Session } from '../api';
import { useAgentName } from '../agent-name';
import type { NeedsYouTab } from '../navigation';
import { ApprovalQueue } from './ApprovalQueue';
import { Inbox } from './Inbox';
import { Today } from './Today';

/**
 * The queues Collections replaced (2026-10-31), kept at their old hashes so deep links work: Drafts, Replies (every reply
 * option lives in the Inbox) and Today. The first tab leads back to Collections.
 */
export function NeedsYouHub({ session, tab, id }: { session: Session; tab: NeedsYouTab; id: string | null }) {
  const agent = useAgentName();
  const tabs: { id: NeedsYouTab | 'collections'; label: string; hint: string }[] = [
    { id: 'collections', label: 'Collections', hint: `${agent}’s caseload` },
    { id: 'approvals', label: 'Drafts', hint: `${agent}’s emails to approve` },
    { id: 'inbox', label: 'Replies', hint: 'Customer mail to decide' },
    { id: 'today', label: 'Today', hint: 'The plan for today' },
  ];
  return <div className="ny-hub">
    <nav className="ny-tabs" aria-label="Queues">
      {tabs.map(t => <a key={t.id} href={`#${t.id}`} className={t.id === tab ? 'active' : ''}
        title={t.hint} aria-current={t.id === tab ? 'page' : undefined}>{t.label}</a>)}
    </nav>
    {tab === 'approvals' ? <ApprovalQueue key={id ?? ''} session={session} initialId={id} />
        : tab === 'inbox' ? <Inbox key={id ?? ''} session={session} initialId={id} /> : <Today />}
  </div>;
}
